var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CcDownload',{attrs:{"data":_vm.data,"default-app":{
    name: '此处填写标题',
    description: '此处填写需求描述，需求描述内容支持两行显示'
  },"show-logo":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }